function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInstantBooking = function SvgInstantBooking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    style: {
      enableBackground: "new 0 0 18 18"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    style: {
      fill: "#f4c064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8 10.4H4.9c-.3 0-.5-.3-.3-.6l5.3-6.7c.2-.3.7-.1.6.3l-.9 3.9h3.9c.3 0 .5.3.3.6L9 14.1c-.2.3-.7.1-.6-.3l.4-3.4z",
    style: {
      fill: "#102a5e"
    }
  }));
};
export default SvgInstantBooking;